module.exports = __webpack_public_path__ + "img/report-gm.34566855.png";